export enum ProcessamentoSituacao {
  EM_EXECUCAO = 'EM_EXECUCAO',
  PENDENTE = 'PENDENTE',
  EXECUTADO = 'EXECUTADO'
}
